import * as z from "zod";
import { isAfter, endOfDay } from "date-fns";
import { requiredString } from "components/form/utils";

export const draftTimesheetLogSchema = z.object({
    date: z
        .string()
        .nonempty("Date is required")
        .refine(
            (val) => {
                const date = new Date(val);
                const today = endOfDay(new Date());
                return !isAfter(date, today);
            },
            {
                message: "Date cannot be in the future",
            }
        ),
    tag: requiredString(),
    logged_hours: z
        .string()
        .min(1, "Hours are required")
        .refine(
            (value) => {
                const parsedValue = parseFloat(value);
                return (
                    !isNaN(parsedValue) && parsedValue > 0 && parsedValue % 0.5 === 0
                );
            },
            {
                message:
                    "Please enter time in 30-minute increments (0.5, 1, 1.5, etc.)",
            }
        )
        .default("0.5"),
    description: z.string().min(1, "Description is required"),
});
